/* global SideDrawer */

/* =====================================================
   GLOBAL CART DRAWER OVERLAY (SINGLE SOURCE OF TRUTH)
   ===================================================== */
const CartDrawerOverlay = (() => {
  let overlay = document.getElementById('CartDrawerOverlay');

  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'CartDrawerOverlay';
    overlay.className = 'cart-drawer-overlay';
    document.body.appendChild(overlay);
  }

  let isOpen = false;

  function lockScroll() {
    document.body.classList.add('cart-scroll-lock');
  }

  function unlockScroll() {
    document.body.classList.remove('cart-scroll-lock');
  }

  function show() {
    if (isOpen) return;
    isOpen = true;
    overlay.classList.add('is-visible');
    lockScroll();
  }

  function hide() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-visible');
    unlockScroll();
  }

  overlay.addEventListener('click', () => {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
  });

  return { show, hide };
})();

/* =====================================================
   DESKTOP CART DRAWER (THEME / SIDEDRAWER)
   ===================================================== */
class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.openHandler = this.handleOpen.bind(this);
    this.closeHandler = this.close.bind(this, null);
    this.refreshHandler = this.refreshHandler.bind(this);

    this.afterOpenHandler = () => {
      requestAnimationFrame(() => {
        if (window.theme?.manuallyLoadImages) {
          theme.manuallyLoadImages(this);
        }
        this.querySelectorAll('cc-cart-cross-sell').forEach(el => el.init?.());
      });
    };

    document.addEventListener('dispatch:cart-drawer:open', this.openHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);

    this.addEventListener('on:cart-drawer:after-open', this.afterOpenHandler);
    this.addEventListener('on:cart:after-merge', this.afterOpenHandler);
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:open', this.openHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeHandler);
    document.removeEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
  }

  handleOpen(evt) {
    if (window.innerWidth <= 768) return; // desktop only
    this.open(evt?.detail?.opener || null);
    CartDrawerOverlay.show();

    this.dispatchEvent(
      new CustomEvent('on:cart-drawer:after-open', { bubbles: true })
    );
  }

  close(reason = null) {
    super.close(reason);
    CartDrawerOverlay.hide();
  }

  refreshHandler() {
    const form = this.querySelector('cart-form');
    if (form?.refresh) {
      requestAnimationFrame(() => form.refresh());
    }
  }
}

window.customElements.define('cart-drawer', CartDrawer);

/* =====================================================
   MOBILE CART DRAWER (CUSTOM)
   ===================================================== */
(() => {
  const drawer = document.getElementById('MobileCartDrawer');
  if (!drawer) return;

  const itemsEl = drawer.querySelector('.mobile-cart-drawer__items');
  const closeBtn = drawer.querySelector('.mobile-cart-drawer__close');
  const totalEl = drawer.querySelector('.mini-cart-total');

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function openMobileDrawer() {
    if (!isMobile()) return;
    drawer.classList.add('active');
    CartDrawerOverlay.show();
  }

  function closeMobileDrawer() {
    drawer.classList.remove('active');
    CartDrawerOverlay.hide();
  }

  closeBtn?.addEventListener('click', () => {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
  });

  document.addEventListener('dispatch:cart-drawer:open', openMobileDrawer);
  document.addEventListener('dispatch:cart-drawer:close', closeMobileDrawer);

  window.addEventListener('resize', () => {
    if (!isMobile()) closeMobileDrawer();
  });

  /* ------------------------------
     MOBILE CART CONTENT UPDATE
     ------------------------------ */
  function formatRON(cents) {
    return typeof cents === 'number' ? `${cents / 100} RON` : '0 RON';
  }

  window.__updateMobileCart = function () {
    if (!isMobile()) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        itemsEl.innerHTML = '';

        if (!cart.items.length) {
          itemsEl.innerHTML = '<p style="text-align:center;">Coșul tău este gol</p>';
        }

        cart.items.forEach(item => {
          const img =
            item.image ||
            (item.featured_image && item.featured_image.url) ||
            '';

          itemsEl.insertAdjacentHTML(
            'beforeend',
            `
            <div class="mobile-cart-drawer__item">
              <img src="${img}" alt="">
              <div class="info">
                <div>${item.product_title}</div>
                <div>${formatRON(item.price)}</div>
              </div>
              <div style="margin-left:auto;">x${item.quantity}</div>
            </div>
          `
          );
        });

        if (totalEl) {
          totalEl.textContent = 'Total: ' + formatRON(cart.total_price);
        }
      });
  };
})();

/* =====================================================
   ADD-TO-CART → OPEN DRAWER (UNIFIED)
   ===================================================== */
document.addEventListener(
  'submit',
  (e) => {
    const form = e.target.closest('form[action^="/cart/add"]');
    if (!form) return;

    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: form } })
      );

      if (window.__updateMobileCart) {
        window.__updateMobileCart();
      }
    }, 300);
  },
  true
);
